import { ShieldCheck } from "lucide-react";

export const SampleReport = () => (
  <section data-testid="sample-report-section" className="bg-[#F7F6F2] py-24 px-6 md:px-12">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
      <div>
        <p className="text-[#8A6A00] text-xs font-semibold tracking-widest uppercase">The deliverable</p>
        <h2 className="mt-3 font-heading font-extrabold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#14213D]">
          See what a certified report looks like.
        </h2>
        <p className="mt-6 text-base text-[#5B6474] leading-relaxed max-w-lg">
          Every Veristamp report ends with a full cryptographic verification page: photo fingerprints, UTC capture
          timestamps, device attestation, and the complete signature audit trail. The PDF regenerates on every
          signature or decline event — a decline with comment is evidence too.
        </p>
        <ul className="mt-8 space-y-3 text-sm text-[#5B6474]">
          {["Room-by-room photo record with condition notes", "SHA-256 fingerprint listed beside every photo", "Signature page with up to five countersigners", "Verification instructions any third party can follow"].map((t, i) => (
            <li key={i} className="flex items-center gap-3">
              <ShieldCheck className="w-4 h-4 text-[#C9A227] shrink-0" />
              {t}
            </li>
          ))}
        </ul>
      </div>
      <div className="relative flex justify-center">
        <div
          data-testid="sample-report-preview"
          className="relative w-full max-w-md bg-white rounded-lg shadow-2xl border border-black/5 overflow-hidden"
        >
          <img src="/assets/veristamp_pdf_header.svg" alt="Veristamp certified condition report PDF with SHA-256 verification page" width="448" height="62" loading="lazy" className="w-full h-auto" />
          <div className="p-6 space-y-3">
            <div className="h-2.5 rounded bg-[#5B6474]/20 w-11/12" />
            <div className="h-2.5 rounded bg-[#5B6474]/20 w-full" />
            <div className="h-2.5 rounded bg-[#5B6474]/20 w-3/4" />
            <div className="grid grid-cols-3 gap-3 pt-3">
              {[0, 1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="h-20 rounded bg-[#2C3B5E]/15" />
              ))}
            </div>
            <div className="pt-3 space-y-2">
              <div className="h-2 rounded bg-[#5B6474]/15 w-2/3 font-mono" />
              <div className="h-2 rounded bg-[#5B6474]/15 w-1/2" />
            </div>
            <div className="flex items-center justify-between pt-4 border-t border-[#5B6474]/15">
              <span className="text-[10px] font-mono text-[#5B6474]">SHA-256 · 7bd4…09af</span>
              <span className="text-[10px] font-mono text-[#5B6474]">Signed · 3/3</span>
            </div>
          </div>
          <div className="absolute top-3 right-3 flex items-center gap-1.5 bg-[#C9A227] rounded-full px-3 py-1 shadow-md">
            <ShieldCheck className="w-3.5 h-3.5 text-[#14213D]" />
            <span className="text-[10px] font-heading font-bold text-[#14213D] tracking-widest uppercase">Certified</span>
          </div>
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <span className="font-heading font-extrabold text-6xl tracking-[0.3em] text-[#C9A227]/30 rotate-[-24deg] border-4 border-[#C9A227]/30 rounded px-6 py-2">
              PREVIEW
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
